import React from 'react';
import styled from 'styled-components';
import CustomImg from '../common/image/CustomImg';
import CustomLabel from '../common/label/CustomLabel';
import NormalBtn from '../common/button/NormalBtn';
import CustomTitle from '../common/title/CustomTitle';
import { useHistory } from 'react-router-dom';


const SrMyCartEmptyBlock = styled.div`
    width: 100%;
    height: 500px;
    text-align: center;
    vertial-align: center;
`;

const SrMyCartEmptyBtnBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;


const SrMyCartEmpty = () => {

    const history = useHistory();

    const handlerBtnClick = () => {
        history.push('/br')
    }

    return (
        <SrMyCartEmptyBlock>
            <CustomImg width='270px' height='158px' marginTop="100px"
                img_src='/assets/images/common/empty-cart.png' />
            <CustomTitle title="장바구니에 상품이 없어요 :-("
                textColor="#111" marginTop="40px" fontWeight="400"
                marginBottom="18px" />
            <CustomLabel text="상품을 담아 나만의 견적서를 만들어 보세요."
                color="#333" />
            <SrMyCartEmptyBtnBlock>
                <NormalBtn text="상품 담으러 가기"
                    float="left"
                    width="170px" height="40px" borderRadius="20px"
                    marginTop="30px" fontWeight="300" fontSize="16px"
                    minWidth="170px" onClick={handlerBtnClick} />
            </SrMyCartEmptyBtnBlock>

        </SrMyCartEmptyBlock>
    );
};

export default SrMyCartEmpty;